 

const MandatoryField = () => {
  return <span style={{ color: "red" }}>*</span>;
};

export default MandatoryField;
